import script from "./AppTitle.vue?vue&type=script&lang=js"
export * from "./AppTitle.vue?vue&type=script&lang=js"

import "./AppTitle.vue?vue&type=style&index=0&id=26d8d2e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d8d2e2"]])

export default __exports__